@if (showActions()) {
    <div class="feature-buttons">
        @if (showMemberButton()) {
            <woa-button class="feature-buttons-button"
                        [prominence]="ButtonProminence.LOW"
                        [layout]="ButtonLayout.VERTICAL"
                        [style]="ButtonStyle.OUTLINE"
                        [shape]="ButtonShape.ROUNDED"
                        [icon]="'star'"
                        [label]="identityModel.isGuestUser() ? 'woa.button.feature-button.login' : 'woa.button.feature-button.profile'"
                        (onActivate)="member()"></woa-button>
        }
        @if (showLoyaltyCard()) {
            <woa-loyalty-card class="feature-buttons-button card" woa-activatable
                              [card]="this.identityModel.loyaltyCards()[0]" [buttonMode]="true"
                              (onActivate)="loyaltyCards()"></woa-loyalty-card>
        }
        @if (showGroupOrderButton()) {
            <woa-button class="feature-buttons-button"
                        [prominence]="ButtonProminence.LOW"
                        [layout]="ButtonLayout.VERTICAL"
                        [style]="ButtonStyle.OUTLINE"
                        [shape]="ButtonShape.ROUNDED"
                        [label]="'woa.button.feature-button.groupOrder'"
                        (onActivate)="groupOrder()">
                <woa-group-order-summary-icon [showWithoutGroupOrder]="true"
                                              [countColorPair]="'success-message'"></woa-group-order-summary-icon>
            </woa-button>
        }
        @if (showDealButton()) {
            <woa-button class="feature-buttons-button"
                        [prominence]="ButtonProminence.LOW"
                        [layout]="ButtonLayout.VERTICAL"
                        [style]="ButtonStyle.OUTLINE"
                        [shape]="ButtonShape.ROUNDED"
                        [label]="identityModel.dealCodesAvailable() ? 'woa.button.feature-button.dealCode' : 'woa.button.feature-button.deal'"
                        (onActivate)="deal()">
                <woa-deal-summary-icon></woa-deal-summary-icon>
            </woa-button>
        }
    </div>
}
@if (allowShowAppliedDeals() && configurationModel.isWaiterActor() && !showDealButton()) {
    <woa-applied-deals-panel class="applied-deals"
                             [hideTitle]="true" [hideMessage]="true"></woa-applied-deals-panel>
}
